import {
  useState,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import DateRanges from '@app/dashboard/components/inner_layout/DateRanges';
import type { TAppliedRanges } from '@app/dashboard/types/innerLayout/date-ranges';
import { getLang } from '@app/dashboard/utils/localStorageUtils';
import { formatToISODateTimeUTC } from '@app/dashboard/utils/dateFormats';
import styles from './header.module.scss';

export interface ISummaryFilters {
  start_time?: string;
  end_time?: string;
}

interface IHeaderProps {
  filters: ISummaryFilters;
  onFiltersChange: (filters: ISummaryFilters) => void;
}

export const Header = ({ filters, onFiltersChange }: IHeaderProps) => {
  const { t } = useTranslation();
  const lang = getLang();

  const wrapperRef = useRef<any>();

  const [appliedRanges, setAppliedRanges] = useState<TAppliedRanges>({});

  const handleRangesChange = (ranges: TAppliedRanges) => {
    setAppliedRanges(ranges);
    if (ranges.start && ranges.end) {
      onFiltersChange({
        ...filters,
        start_time: formatToISODateTimeUTC(ranges.start, 'Z', 'start'),
        end_time: formatToISODateTimeUTC(ranges.end, 'Z', 'end'),
      });
    }
  };

  return (
    <div className={styles['header']} ref={wrapperRef}>
      <div className={styles['header__title']}>
        {t('innerLayout.summaryPage.title')}
      </div>

      <DateRanges
        appliedRanges={appliedRanges}
        handleRangesChange={handleRangesChange}
        lang={lang}
      />
    </div>
  );
};
